(function () {
  var cards = Array.prototype.slice.call(document.querySelectorAll('.team-card'));
  var tabs = document.querySelectorAll('.db-tab');
  var conf = document.getElementById('t-conf');
  var q = document.getElementById('t-q');
  var count = document.getElementById('t-count');
  var empty = document.getElementById('t-empty');
  if (!cards.length || !conf) return;
  var level = 'all';
  function apply() {
    var shown = 0;
    cards.forEach(function (c) {
      var ok = (level === 'all' || c.dataset.level === level) &&
               (!conf.value || c.dataset.conf === conf.value) &&
               (!q.value || c.dataset.name.indexOf(q.value.toLowerCase()) !== -1);
      c.style.display = ok ? '' : 'none';
      if (ok) shown++;
    });
    count.textContent = shown + ' PROGRAMS';
    empty.style.display = shown ? 'none' : 'block';
  }
  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      tabs.forEach(function (x) { x.classList.remove('on'); });
      t.classList.add('on'); level = t.dataset.level; apply();
    });
  });
  conf.addEventListener('change', apply);
  q.addEventListener('input', apply);
  apply();
})();
